import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { Russian } from "flatpickr/dist/l10n/ru.js";

document.querySelectorAll(".data-picker").forEach((inputDate) => {
	const options = {
		locale: Russian,
		dateFormat: inputDate.dataset.dateFormat || "d-m-Y",
	};
	const listId = inputDate.getAttribute("list");
	const listDates = Array.from(document.querySelectorAll(`#${listId} option`)).map((i) => i.value);

	if (listDates.length > 0) {
		options.enable = listDates;
	}
	if (inputDate.dataset.minToday) {
		options.minDate = "today";
	}

	flatpickr(inputDate, options);
});

document.querySelectorAll(".data-picker-month").forEach((inputDate) => {
	const options = {
		locale: Russian,
		plugins: [
			new monthSelectPlugin({
				dateFormat: inputDate.dataset.dateFormat || "m.y",
				altFormat: inputDate.dataset.altFormat || "m.y",
			}),
		],
	};

	flatpickr(inputDate, options);
});
